import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AppRoutes, ProfileRoutes } from '@core';
import { OrIconComponent } from '@ui-components';

@Component({
  selector: 'lib-dashboard-contact',
  templateUrl: './dashboard-contact.component.html',
  styleUrls: ['./dashboard-contact.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [OrIconComponent]
})
export class DashboardContactComponent {
  private readonly router: Router = inject(Router);

  readonly reasons: string[] = ['Potrzebujesz pomocy?', 'Masz propozycje?', 'Chcesz nowego miasta w Orlikfy?'];

  goToContact(): void {
    this.router.navigate([AppRoutes.PROFILE, ProfileRoutes.CONTACT]);
  }
}
